const API_ORIGIN = (() => {
  try {
    return new URL(process.env.REACT_APP_API_URL || "", window.location.origin).origin;
  } catch {
    return "";
  }
})();

export function resolveMediaUrl(url) {
  if (!url) return "";
  if (/^(data:|blob:|https?:\/\/)/i.test(url)) return url;
  if (url.startsWith("/")) return `${API_ORIGIN}${url}`;
  return url;
}
